import { render } from "./manufacturers.vue?vue&type=template&id=4efb13f6"
import script from "./manufacturers.vue?vue&type=script&lang=js"
export * from "./manufacturers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__